import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/**
 * this is the header view of the application.
 */
const ApplicationHeader = (props) => {
    const classNames = classnames(props.className, 'application-header', {
        'application-header--isSticky': props.isSticky,
        'application-header--isStickyVisible': props.isSticky && props.isStickyVisible
    });

    return (
        <header className={classNames}>
            <div className="u-content">
                <div className="application-header__left">{props.left}</div>
                <div className="application-header__middle">{props.middle}</div>
                <div className="application-header__right">{props.right}</div>
            </div>
        </header>
    );
};

ApplicationHeader.propTypes = {
    left: PropTypes.node,
    middle: PropTypes.node,
    right: PropTypes.node,
    isSticky: PropTypes.bool,
    isStickyVisible: PropTypes.bool,
    className: PropTypes.string
};

export default ApplicationHeader;